// utils/dateFormatter.js

/**
 * Formats a date string to MM/DD/YYYY
 * - Safe for 'YYYY-MM-DD' input (no time)
 * - Safe for full ISO datetime strings
 */
// export const formatDate = (input) => {
//   if (!input) return "—";

//   // If it's a plain date string, format manually to avoid time zone issues
//   if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
//     const [year, month, day] = input.split("-");
//     return `${month}/${day}/${year}`;
//   }

//   // For ISO or datetime strings, use JS Date
//   const date = new Date(input);
//   if (isNaN(date.getTime())) return "Invalid Date";

//   const mm = String(date.getMonth() + 1).padStart(2, "0");
//   const dd = String(date.getDate()).padStart(2, "0");
//   const yyyy = date.getFullYear();

//   return `${mm}/${dd}/${yyyy}`;
// };

// utils/dateFormatter.js

/**
 * Formats a date string to MM/DD/YYYY
 * - Safe for 'YYYY-MM-DD' input (no time)
 * - Smart handling for ISO datetime strings:
 *   - If time is midnight UTC (00:00:00), treats as date-only and uses UTC (no timezone shift)
 *   - If time has actual hours/minutes, uses local timezone
 */
export const formatDate = (input) => {
  if (!input) return "—";

  // If it's a plain date string (YYYY-MM-DD), format manually to avoid timezone issues
  if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
    const [year, month, day] = input.split("-");
    return `${month}/${day}/${year}`;
  }

  // For ISO or datetime strings
  const date = new Date(input);
  if (isNaN(date.getTime())) return "Invalid Date";

  // Check if this looks like a "date-only" value stored at midnight UTC
  // or noon UTC (common patterns for date-only storage)
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  const isDateOnly =
    (hours === 0 || hours === 12) && minutes === 0 && seconds === 0;

  if (isDateOnly) {
    // Use UTC methods to prevent timezone shift for date-only values
    const mm = String(date.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(date.getUTCDate()).padStart(2, "0");
    const yyyy = date.getUTCFullYear();
    return `${mm}/${dd}/${yyyy}`;
  } else {
    // Use local timezone for actual datetime values
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }
};
